require('./blocks/news/news');
require('./blocks/pagination.less');
require('./blocks/product/product');
require('./blocks/products-slider/products-slider');



// WEBPACK FOOTER //
// ./news.js